import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo and Mission */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 rounded-full overflow-hidden flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/0f4196e35f78d87056a996d208b7f641/2a01936c71991026fb04439a944e88b7.jpeg" 
                  alt="PAAM Logo" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h3 className="text-xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                  Peter Akinnubi Apostolic Ministry
                </h3>
                <p className="text-sm text-gray-400">Christ + Nothing = Enough</p>
              </div>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              A global family of Spirit-filled believers unified in the doctrine of Christ, 
              bringing the Gospel from every nation to every nation through the Christ Family Network.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-[#b8144a] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#b8144a] transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#b8144a] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#b8144a] transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-[#b8144a] transition-colors">About Us</Link></li>
              <li><Link to="/cfn" className="text-gray-300 hover:text-[#b8144a] transition-colors">Christ Family Network</Link></li>
              <li><Link to="/training" className="text-gray-300 hover:text-[#b8144a] transition-colors">Global Training</Link></li>
              <li><Link to="/events" className="text-gray-300 hover:text-[#b8144a] transition-colors">Events</Link></li>
              <li><Link to="/resources" className="text-gray-300 hover:text-[#b8144a] transition-colors">Resources</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-[#b8144a]"></i>
                <span className="text-gray-300">info@paamintl.org</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-[#b8144a]"></i>
                <span className="text-gray-300">+234 703 889 4202</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-[#b8144a]"></i>
                <span className="text-gray-300">Sagamu, Nigeria</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 Peter Akinnubi Apostolic Ministry. All rights reserved.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-400 hover:text-[#b8144a] text-sm transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-400 hover:text-[#b8144a] text-sm transition-colors">
              Terms of Service
            </Link>
           
          </div>
        </div>
      </div>
    </footer>
  );
}
